import React from 'react';
import { Dialog, DialogTitle, DialogContent, Typography, Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CHANGE_LOG } from '../../constants/ChangeLog';

function VersionDialog({ open, onClose }) {
    return (
        <Dialog 
            open={open} 
            onClose={onClose} 
            maxWidth="md" 
            fullWidth
            PaperProps={{
                sx: {
                    maxHeight: '80vh', // 80% of the viewport height
                    borderRadius: 1    // Optional: matches your UI style
                }
            }}
        >
            <DialogTitle variant='h4' color="primary" sx={{ m: 0, p: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                What's New in VeriSafe
                <IconButton onClick={onClose}><CloseIcon /></IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {CHANGE_LOG.map((release, index) => (
                    <Box key={index} sx={{ mb: 3 }}>
                        <Typography variant="h6" color="secondary" sx={{ lineHeight: 1.2 }}>
                            {release.title}
                        </Typography>

                        <Box sx={{ display: 'flex', gap: 2, mt: 0.5, mb: 1 }}>
                            <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#0288d1' }}>
                                Frontend: {release.frontend}
                            </Typography>
                            <Typography variant="caption" sx={{ fontWeight: 'bold', color: '#2e7d32' }}>
                                Backend: {release.backend}
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'text.disabled' }}>
                                Released: {release.date}
                            </Typography>
                        </Box>

                        <Box component="ul" sx={{ mt: 1, pl: 2 }}>
                            {release.changes.map((item, i) => (
                                <li key={i}>
                                    <Typography variant="body2">{item}</Typography>
                                </li>
                            ))}
                        </Box>
                    </Box>
                ))}
            </DialogContent>
        </Dialog>
    );
}

export default VersionDialog;